import { Component, OnInit } from '@angular/core';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';

@Component({
  selector: 'app-order-service',
  standalone: false,
  templateUrl: './order-service.component.html',
  styleUrl: './order-service.component.scss'
})
export class OrderServiceComponent implements OnInit {
  // result: any;
   _data: any;
  resourceDef: any;
  gridData: any;
  patient_type:any=''
  config = {
    "submitButton": true,
    "cancelButton": true,
    "filterForm": false,
    "clearOnSave": false,
    "delegateSave": true,
    "cancelRoute": '',
    "allowPagination": false,
    "customButtonsAllowed": false,
    "complex_search": '',
    "noCount": true // Changed to false so count is respected
  };

  currentPage = 1;
  pageSize = 10;

  constructor(
    private dialogConfig: DialogConfig,
    private baseService: BaseService,
    public dialogRef: DialogRef,
    private alerts: AlertsService,
    private smartModalService: SmartModalService
  ) { }

  ngOnInit(): void {
    this._data = this.dialogConfig;
    const currentData = JSON.parse(sessionStorage.getItem('currentData') || '{}');
    this.patient_type=currentData.patientType;
    this.updateGridData();
    // console.log("this.data.resource", this.result);
    
  }

  updateGridData() {
    // if (!this.result || !this.result.data) return;

    // const startIndex = (this.currentPage - 1) * this.pageSize;
    // const endIndex = startIndex + this.pageSize;
    // const paginatedData = this.result.data.slice(startIndex, endIndex);

    // this.gridData = {
    //   resource: paginatedData,
    //   count: this.result.data.length
    // };
    let data = this._data.data;
    this.baseService.get("GET_DISTINCT_DATA", `uhId:${data.uhId},parent_id:${data.parent_id},date:${data.date}`,`patient_assigned_protocols_details`,`emr`).subscribe((res: any) => {
      if (res && res.errCode === 0 && res.resource && res.resource.length) {
        res.resource = res.resource.map(ele => ({
          ...ele,
          patientType: this.patient_type
        }));
        this.gridData = res;
        this.getResource();
      } else {
        this.alerts.error(res.message || "Failed to load data");
      }
    });
  }

  getResource() {
    this.baseService.getResourceDef(this._data.resource, (data: any) => {
      if (data) {
        this.resourceDef = data; // Assigned the loaded JSON config instead of this.result
      }
    });
  }

  // onLimit(event) {
  //   this.pageSize = event.target ? Number(event.target.value) : Number(event);
  //   this.currentPage = 1; // Reset to first page when limit changes
  //   this.updateGridData();
  // }

  onBulkActionClicked(event: any) {
    // if (event && event.action && event.action.action === 'SEND_PROTOCOL_ORDERS') {
    //   const payload = {
    //     data: event.selectedItems // Sending the entire data of selected rows
    //   };

    //   this.baseService.action(payload, event.action.action, event.action.application, event.action.resource, '', '', event.action.args || '').subscribe(
    //     (res: any) => {
    //       if (res && res.errCode === 0) {
    //         // Optional: Handle success (e.g., refresh grid or show success message)
    //         console.log('Orders sent successfully', res);
    //       } else {
    //         console.error('Error sending orders', res);
    //       }
    //     },
    //     (error: any) => {
    //       console.error('API error', error);
    //     }
    //   );
    // }
  }

  buttonAction(event) {
    // When the data grid completes the internal API action successfully, 
    // it automatically emits a "refresh" event right here.
    if (event && event.actionType && event.actionType.action === 'refresh') {
      if (this.smartModalService) {
        this.smartModalService.sendResult(true);
      }
      if (this.dialogRef) {
        this.dialogRef.close(true); // Close the popup
      }
    }
  }

}
